export const siteConfig = {
  description: '',
  themeColor: [
    { media: '(prefers-color-scheme: light)', color: 'white' },
    { media: '(prefers-color-scheme: dark)', color: 'black' },
  ],
  icons: {
    icon: '/favicon.ico',
    shortcut: '/favicon-16x16.png',
    apple: '/apple-touch-icon.png',
  },
  login_ui_slider_interval_duration: 10000,
  login_ui_slider_dot_duration: 0.9,
  login_ui_slider_img_transition: 2,
};
